/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountSearchDownloadResponse} from '../models/AccountSearchDownloadResponse';
import type {EntityDownloadInfoRequest} from '../models/EntityDownloadInfoRequest';
import type {Error} from '../models/Error';

export interface DownloadAccountInfo$Request {
    entityDownloadInfoRequest: EntityDownloadInfoRequest;
}

export interface DownloadAccountInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const downloadAccountInfoRequest = createAction<PayloadData<void, DownloadAccountInfo$Request>>('ACCOUNT_SEARCH_DOWNLOAD_REQUEST__DOWNLOAD_ACCOUNT_INFO__REQUEST');
export const downloadAccountInfoSuccess = createAction<PayloadData<Array<AccountSearchDownloadResponse>, DownloadAccountInfo$Request>>('ACCOUNT_SEARCH_DOWNLOAD_REQUEST__DOWNLOAD_ACCOUNT_INFO__SUCCESS');
export const downloadAccountInfoFailure = createAction<PayloadData<Error, DownloadAccountInfo$Request, true>>('ACCOUNT_SEARCH_DOWNLOAD_REQUEST__DOWNLOAD_ACCOUNT_INFO__FAILURE');

export const downloadAccountInfoActions = [
    downloadAccountInfoRequest,
    downloadAccountInfoSuccess,
    downloadAccountInfoFailure
] as const;

/**
 * @param {EntityDownloadInfoRequest} meta.entityDownloadInfoRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const downloadAccountInfo = (meta: DownloadAccountInfo$Request, config?: DownloadAccountInfo$Config) => {
    return {
        CALL_API: {
            types: downloadAccountInfoActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/search/download/request`,
            TRANSPORT_REQUEST_BODY: meta.entityDownloadInfoRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

